import { Admin, OrganizationAdmin, OrganizationUser, User } from "@/api/lab-base-api-client";
import { Module, Mutation, VuexModule, Action, getModule } from "vuex-module-decorators";
import store from "@/store/index";
import { EditStatus } from "@/types";

export interface IAuthModule {
  _me: User | OrganizationUser | OrganizationAdmin | null;
  _resetPasswordStatus: EditStatus;
  _setPasswordStatus: EditStatus;
}

@Module({
  dynamic: true,
  store,
  name: "auth",
  namespaced: true,
  preserveState: localStorage.getItem("vuex") && JSON.parse(localStorage.getItem("vuex") as string).auth,
})
class AuthModule extends VuexModule implements IAuthModule {
  public _me: User | OrganizationUser | OrganizationAdmin | null = null;

  public _resetPasswordStatus: EditStatus = EditStatus.Edit;

  public _setPasswordStatus: EditStatus = EditStatus.Edit;

  @Mutation
  public changeMe(me: User | OrganizationUser | OrganizationAdmin | null) {
    this._me = me;
  }

  @Mutation
  public changeResetPasswordStatus(status: EditStatus) {
    this._resetPasswordStatus = status;
  }

  @Mutation
  public changeSetPasswordStatus(status: EditStatus) {
    this._setPasswordStatus = status;
  }

  @Action({ rawError: true })
  public commitMe(me: User | OrganizationUser | Admin | OrganizationAdmin | null) {
    this.context.commit("changeMe", me);
  }

  @Action({ rawError: true })
  public commitResetPasswordStatus(status: EditStatus) {
    this.context.commit("changeResetPasswordStatus", status);
  }

  @Action({ rawError: true })
  public commitSetPasswordStatus(status: EditStatus) {
    this.context.commit("changeSetPasswordStatus", status);
  }

  public get me() {
    return this._me;
  }

  public get resetPasswordStatus() {
    return this._resetPasswordStatus || EditStatus.Edit;
  }

  public get setPasswordStatus() {
    return this._setPasswordStatus || EditStatus.Edit;
  }
}

export default getModule(AuthModule);
